
define('text!modules/creatives/bulkedit/templates/dialog.html',[],function () { return '<div class="edit"></div>\n<div class="assignment"></div>\n<div class="review"></div>';});

